export enum DayCheckMode {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}

export enum DatePickerType {
  CALENDAR = 'calendar',
  WEEK = 'week',
}
